// extracted by mini-css-extract-plugin
module.exports = {"trash":"products-table-view-trash_trash__1b7B3"};